module.exports = __webpack_public_path__ + "front/img/menu2.513bbeb0.png";